import { useEffect, useState } from 'react'
import { Col, Input, Row } from 'antd'
import { TextAreaProps } from 'antd/lib/input'
import styles from './styles.module.scss'
export default function CustomTextArea(props: TextAreaProps) {
  const { value, ...restProps } = props
  const [innerValue, setInnerValue] = useState<string>('')

  useEffect(() => {
    setInnerValue((value as string) ?? '')
  }, [value])

  return (
    <Row>
      <Col span={24}>
        <Input.TextArea {...restProps} value={value}></Input.TextArea>
      </Col>
      {props?.maxLength ? (
        <Col span={24} className={styles['length-container']}>
          <span className={styles['maxlength']}>
            {innerValue.length}/{props?.maxLength ?? 100}
          </span>
        </Col>
      ) : null}
    </Row>
  )
}
import { useEffect, useState } from 'react'
import { Col, Input, Row } from 'antd'
import { TextAreaProps } from 'antd/lib/input'
import styles from './styles.module.scss'
export default function CustomTextArea(props: TextAreaProps) {
  const { value, ...restProps } = props
  const [innerValue, setInnerValue] = useState<string>('')

  useEffect(() => {
    setInnerValue((value as string) ?? '')
  }, [value])

  return (
    <Row>
      <Col span={24}>
        <Input.TextArea {...restProps} value={value}></Input.TextArea>
      </Col>
      {props?.maxLength ? (
        <Col span={24} className={styles['length-container']}>
          <span className={styles['maxlength']}>
            {innerValue.length}/{props?.maxLength ?? 100}
          </span>
        </Col>
      ) : null}
    </Row>
  )
}
